import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'

import { setDraggableContainerMountRef } from '@/store/sessionSlice'
import getCanvasSize from '@/utils/canvasSize'

export const useCanvasSize = (extraHeight: number = 0) => {
  const location = useLocation()
  const dispatch = useDispatch()

  const containerRef = useRef<HTMLDivElement>(null)
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  const updateSize = useCallback(() => {
    if (containerRef.current) {
      const { availableWidth, availableHeight } = getCanvasSize(
        location.pathname,
        extraHeight,
      )
      dispatch(setDraggableContainerMountRef(false))

      setDimensions({
        width: availableWidth,
        height: availableHeight,
      })
    }
  }, [location, getCanvasSize])

  const setCanvasSize = (width: number, height: number) => {
    setDimensions({ width, height })
  }

  useEffect(() => {
    updateSize()
    window.addEventListener('resize', updateSize)
    return () => window.removeEventListener('resize', updateSize)
  }, [updateSize])

  return { containerRef, dimensions, reloadCanvas: updateSize, setCanvasSize }
}
